export default "__VITE_ASSET__BUFMcMZh__"